import styles from './styles.module.scss';
import { useMousePosition } from '../../hooks/useMousePosition';
import { useEffect, useRef, useState } from 'react';
import olho from './assets/Olhos.png';
import boca from './assets/Boca01.png';
import cabeca1 from './assets/Rosto_Masc.png';
import corpoHomem from './assets/Roupa_Masc01.png';

import cabelo1 from './assets/Cabelo1.png';
import calvo from './assets/Cabelo2.png';
import cabelo3 from './assets/Cabelo3.png';
import emo from './assets/Cabelo04.png';

import rostoFeminino from './assets/Rosto_Fem.png';
import corpoMulher from './assets/Roupa_Fem01.png';

import roupaX from './assets/roupaX.png';
import roupaX2 from './assets/RoupaX2.png';
import roupaX3 from './assets/RoupaX3.png';
import roupaX4 from './assets/RoupaX4.png';
import roupaX5 from './assets/RoupaX5.png';

import roupaXNeck from './assets/RoupaXNeck.png';
import roupaX2Neck from './assets/RoupaX2Neck.png';
import roupaX3Neck from './assets/RoupaX3Neck.png';
import roupaX4Neck from './assets/RoupaX4Neck.png';
import roupaX5Neck from './assets/RoupaX5Neck.png';


import cabeloAtras1 from './assets/Cabelo04_Tras.png';
import cabeloAtras2 from './assets/CabeloAtras2.png';
import cabeloAtras3 from './assets/CabeloAtras3.png';
import axios from 'axios';
import { User } from '../../types';
import { verifyRoutePermissions } from '../../globalFunctions';
import { useNavigate } from 'react-router-dom';
const cabelos = [
    { imagem: cabelo1, left: '-1vw', bottom: '7vw', size: '1.2' },
    { imagem: calvo, left: '0vw', bottom: '5vw', size: '1.1' },
    { imagem: cabelo3, left: '-.25vw', bottom: '7.5vw', size: '1' },
    { imagem: emo, left: '-.5vw', bottom: '7vw', size: '1.1' },
    { imagem: '', left: '', bottom: '', size: '' }
];

const cabelosTras = [
    { imagem: '', left: '0vw', bottom: '6vw', size: '1' },
    { imagem: cabeloAtras1, left: '0vw', bottom: '6vw', size: '1' },
    { imagem: cabeloAtras2, left: '0vw', bottom: '6vw', size: '1' },
    { imagem: cabeloAtras3, left: '0vw', bottom: '6vw', size: '1' }
];
const cabecas = [cabeca1, rostoFeminino];
const corpos = [corpoHomem, corpoMulher,roupaX,roupaX2,roupaX3,roupaX4,roupaX5];
const pescocos = [null,null,roupaXNeck,roupaX2Neck,roupaX3Neck,roupaX4Neck,roupaX5Neck]


export default function Personagem({Personagem,className}) {
const navigate = useNavigate()
    const mousePos = useMousePosition();
    const refLeftEye = useRef(null);
    const refRightEye = useRef(null);
    const [leftEyePosition, setLeftEyePosition] = useState({ x: 0, y: 0 });
    const [rightEyePosition, setRightEyePosition] = useState({ x: 0, y: 0 });
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const [personagem,setPersonagem] = useState({ indiceCabelo : 0,
        indiceRosto : 0,
        indiceCorpo: 0,
        indiceCabeloAtras: 0,
        corOlhos: 0,
        tomOlhos: 0,
        fkUserId: userAuth.id,
        corRoupa: 0,
        corCabelo: 0,
        tomCabelo: 0,
        tomPele: 0,})


    if(Personagem && Personagem.Personagem) {
        setPersonagem(Personagem.Personagem)
    }

    //Função de interpolação linear
    const lerp = (start, end, factor) => start + (end - start) * factor;

    //Garante  que a pupila fique dentro dos limites
    const limitToRadius = (x, y, maxRadius) => {
        const distance = Math.sqrt(x * x + y * y); //Distância do centro
        if (distance > maxRadius) {
            const ratio = maxRadius / distance;
            return { x: x * ratio, y: y * ratio }; //Normaliza a posição para dentro do limite
        }
        return { x, y }; // Retorna a posição original se dentro do limite
    };

    useEffect(() => {
        const calculateSmoothPosition = (eyeRef, currentPos) => {
            if (eyeRef.current) {
                const eyeRect = eyeRef.current.getBoundingClientRect();
                const eyeCenterX = eyeRect.left + eyeRect.width / 2;
                const eyeCenterY = eyeRect.top + eyeRect.height / 2;

                //ângulo entre o olho e o mouse
                const angle = Math.atan2(mousePos.y - eyeCenterY, mousePos.x - eyeCenterX);
                const maxRadius = eyeRect.width / 12; // limite de movimento da pupila / tamanho da sclera

                
                const targetX = maxRadius * Math.cos(angle);
                const targetY = maxRadius * Math.sin(angle);

                
                const x = lerp(currentPos.x, targetX, 0.2); // 0.1 ajusta a suavidade
                const y = lerp(currentPos.y, targetY, 0.2);

                //çlimita pra dentro da sclera
                const limitedPosition = limitToRadius(x, y, maxRadius);

                return limitedPosition;
            }
            return currentPos;
        };

        
        setLeftEyePosition((prev) => calculateSmoothPosition(refLeftEye, prev));
        setRightEyePosition((prev) => calculateSmoothPosition(refRightEye, prev));
    }, [mousePos]);

    useEffect(() => {
        const user = verifyRoutePermissions(['auth', 'email.verified'], navigate);
        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);


    useEffect(()=>{
        handleCharacter()
    },[userAuth])


    useEffect(() => {
        console.log('Personagem atualizado:', personagem);
    }, [personagem]);
    

    const handleCharacter  = async () => {
        var result 
        try {
             result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/personagem/user`,{userId: userAuth.id})
             console.log(result.data)
            setPersonagem(result.data)
            document.documentElement.style.setProperty('--valor-rotate', `${result.data.corRoupa}deg`);
            document.documentElement.style.setProperty('--valor-luz-rotate', `${result.data.tomRoupa}%`);
            document.documentElement.style.setProperty('--valor-pele', `${result.data.tomPele}%`);
            document.documentElement.style.setProperty('--valor-luz-cabelo', `${result.data.tomCabelo}%`);
            document.documentElement.style.setProperty('--valor-cor-cabelo', `${result.data.corCabelo}deg`);
            document.documentElement.style.setProperty('--valor-tom-olhos', `${result.data.tomOlhos}%`);
            document.documentElement.style.setProperty('--valor-cor-olhos', `${result.data.corOlhos}deg`);
            } catch(error) {
                const response = {
                    message: 'Erro ao buscar status dos módulos',
                    error: error
                };
        
               return response;

        }

    }

    return (
        <div className={`${styles.personagem} ${className}`}>
            <div style={{ backgroundImage: `url(${cabecas[Personagem? Personagem.indiceRosto: personagem.indiceRosto]})` }} className={`${styles.rosto} ${styles.itemPersonagem}`}>
            </div>        


            <div className={styles.olhos}>
                <img
                    ref={refLeftEye}
                    className={styles.leftEye}
                    src={olho}
                    style={{
                        transform: `translate(${leftEyePosition.x}px, ${leftEyePosition.y}px)`,
                    }}
                />
                <img
                    ref={refRightEye}
                    className={styles.rightEye}
                    src={olho}
                    style={{
                        transform: `translate(${rightEyePosition.x}px, ${rightEyePosition.y}px)`,
                    }}
                />
            </div>
            <img className={styles.boca} src={boca} />
            <div
                style={{
                    backgroundImage: `url(${cabelos[Personagem? Personagem.indiceCabelo : personagem.indiceCabelo].imagem})`,
                    bottom: cabelos[Personagem? Personagem.indiceCabelo : personagem.indiceCabelo].bottom,
                    left: cabelos[Personagem? Personagem.indiceCabelo : personagem.indiceCabelo].left,
                    transform: `scale(${cabelos[Personagem? Personagem.indiceCabelo : personagem.indiceCabelo].size})`,
                }}
                className={`${styles.cabelo} ${styles.itemPersonagem}`}
            ></div>

            <div
             style={{
              backgroundImage: `url(${cabelosTras[ Personagem? Personagem.indiceCabeloAtras : personagem.indiceCabeloAtras].imagem})`,
              bottom: cabelosTras[Personagem? Personagem.indiceCabeloAtras : personagem.indiceCabeloAtras].bottom,
             left: cabelosTras[Personagem? Personagem.indiceCabeloAtras : personagem.indiceCabeloAtras].left,
             transform: `scale(${cabelosTras[Personagem? Personagem.indiceCabeloAtras : personagem.indiceCabeloAtras].size})`,
                   }}
             className={`${styles.cabeloTras} ${styles.itemPersonagem}`}
             ></div>
          
            <div style={{ backgroundImage: `url(${corpos[Personagem? Personagem.indiceCorpo : personagem.indiceCorpo]})` }} className={`${styles.corpo} ${styles.itemPersonagem}`}></div>
            {pescocos[Personagem? Personagem.indiceCorpo : personagem.indiceCorpo] && (
                <div
                    style={{ backgroundImage: `url(${pescocos[Personagem? Personagem.indiceCorpo : personagem.indiceCorpo]})` }}
                    className={`${styles.pescoco} ${styles.itemPersonagem}`}
                ></div>
            )}
        </div>
    );
}
